import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/admin.css";

const menuItems = [
  {
    label: "ユーザ管理",
    description: "BANやアカウント操作",
    path: "/admin/users-management",
    cardBg: "#eff6ff",
    cardBorder: "#93c5fd",
    iconBg: "#bfdbfe",
    iconColor: "#1e3a8a",
    labelColor: "#1e3a8a",
    descColor: "#2563eb",
    arrowColor: "#1e3a8a",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <circle cx="9" cy="7" r="4" />
        <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        <path d="M21 21v-2a4 4 0 0 0-3-3.85" />
      </svg>
    ),
  },
  {
    label: "ユーザ別ログ",
    description: "投稿履歴の確認",
    path: "/admin/users-posts",
    cardBg: "#f0fdf4",
    cardBorder: "#86efac",
    iconBg: "#bbf7d0",
    iconColor: "#14532d",
    labelColor: "#14532d",
    descColor: "#16a34a",
    arrowColor: "#14532d",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <line x1="10" y1="9" x2="8" y2="9" />
      </svg>
    ),
  },
  {
    label: "通報一覧",
    description: "通報された投稿の管理",
    path: "/admin/reports",
    cardBg: "#fff1f2",
    cardBorder: "#fda4af",
    iconBg: "#fecdd3",
    iconColor: "#7f1d1d",
    labelColor: "#7f1d1d",
    descColor: "#dc2626",
    arrowColor: "#7f1d1d",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
  },
  {
    label: "営業所管理",
    description: "営業所の追加・編集",
    path: "/admin/depots",
    cardBg: "#ecfeff",
    cardBorder: "#67e8f9",
    iconBg: "#a5f3fc",
    iconColor: "#164e63",
    labelColor: "#164e63",
    descColor: "#0891b2",
    arrowColor: "#164e63",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M3 21h18" />
        <path d="M5 21V7l8-4v18" />
        <path d="M19 21V11l-6-4" />
        <line x1="9" y1="9" x2="9" y2="9.01" />
        <line x1="9" y1="12" x2="9" y2="12.01" />
        <line x1="9" y1="15" x2="9" y2="15.01" />
        <line x1="9" y1="18" x2="9" y2="18.01" />
      </svg>
    ),
  },
  {
    label: "車両管理",
    description: "車両の追加・編集・削除",
    path: "/admin/buses",
    cardBg: "#fffbeb",
    cardBorder: "#fcd34d",
    iconBg: "#fde68a",
    iconColor: "#78350f",
    labelColor: "#78350f",
    descColor: "#d97706",
    arrowColor: "#78350f",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <rect x="1" y="3" width="15" height="13" rx="2" />
        <path d="M16 8h4a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2" />
        <circle cx="12" cy="20" r="1" />
        <circle cx="6" cy="20" r="1" />
      </svg>
    ),
  },
  {
    label: "路線管理",
    description: "路線の追加・編集",
    path: "/admin/routes",
    cardBg: "#faf5ff",
    cardBorder: "#c4b5fd",
    iconBg: "#ddd6fe",
    iconColor: "#3b0764",
    labelColor: "#3b0764",
    descColor: "#7c3aed",
    arrowColor: "#3b0764",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M3 12h18" />
        <path d="M3 6l9-3 9 3" />
        <path d="M3 18l9 3 9-3" />
      </svg>
    ),
  },
  {
    label: "始発地管理",
    description: "始発バス停の追加・編集・削除",
    path: "/admin/starts",
    cardBg: "#f0fdfa",
    cardBorder: "#5eead4",
    iconBg: "#99f6e4",
    iconColor: "#134e4a",
    labelColor: "#134e4a",
    descColor: "#0d9488",
    arrowColor: "#134e4a",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
    ),
  },
  {
    label: "特別日管理",
    description: "暦どおりでないダイヤで走る日の登録",
    path: "/admin/special-dates",
    cardBg: "#fdf2f8",
    cardBorder: "#f9a8d4",
    iconBg: "#fbcfe8",
    iconColor: "#831843",
    labelColor: "#831843",
    descColor: "#db2777",
    arrowColor: "#831843",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <line x1="12" y1="14" x2="12" y2="18" />
        <line x1="10" y1="16" x2="14" y2="16" />
      </svg>
    ),
  },
  {
    label: "お知らせ管理",
    description: "お知らせの作成・編集・削除",
    path: "/admin/notices",
    cardBg: "#fff7ed",
    cardBorder: "#fdba74",
    iconBg: "#fed7aa",
    iconColor: "#7c2d12",
    labelColor: "#7c2d12",
    descColor: "#ea580c",
    arrowColor: "#7c2d12",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    ),
  },
];

export default function AdminMenuPage() {
  const navigate = useNavigate();

  return (
    <div className="adm-page adm-page-narrow">
      {/* ヘッダー */}
      <div style={{ marginBottom: "1.75rem" }}>
        <div className="adm-header-left" style={{ marginBottom: ".25rem" }}>
          <h2 className="adm-title">管理者メニュー</h2>
          <span className="adm-badge adm-badge--red">super_admin</span>
        </div>
        <p style={{ fontSize: ".8125rem", color: "var(--adm-text-muted)", margin: 0 }}>
          各機能を選択してください
        </p>
      </div>

      {/* カードグリッド */}
      <div className="adm-menu-grid">
        {menuItems.map((item) => (
          <MenuCard key={item.path} item={item} onClick={() => navigate(item.path)} />
        ))}
      </div>
    </div>
  );
}

function MenuCard({ item, onClick }) {
  return (
    <div
      className="adm-menu-card"
      onClick={onClick}
      style={{
        background: item.cardBg,
        borderColor: item.cardBorder,
      }}
    >
      <div
        className="adm-menu-card__icon"
        style={{ background: item.iconBg, color: item.iconColor }}
      >
        {item.icon}
      </div>

      <div>
        <div className="adm-menu-card__label" style={{ color: item.labelColor }}>
          {item.label}
        </div>
        <div className="adm-menu-card__desc" style={{ color: item.descColor }}>
          {item.description}
        </div>
      </div>

      <div className="adm-menu-card__arrow" style={{ color: item.arrowColor }}>
        →
      </div>
    </div>
  );
}
